export default __webpack_public_path__ + "static/media/4_Still.04263b09.jpg";